
/* Servicios Brand Lab: interacción táctil accesible. Escritorio conserva hover. */
(function(){
  function init(){
    var showcase=document.querySelector('#bl [data-bl-service-showcase]');
    if(!showcase||showcase.dataset.mobileServicesInit)return;
    showcase.dataset.mobileServicesInit='1';
    var items=Array.prototype.slice.call(showcase.querySelectorAll('.bl-service-item'));
    function setActive(item){
      items.forEach(function(el){
        var active=el===item;
        el.classList.toggle('is-active',active);
        el.setAttribute('aria-expanded',String(active));
      });
    }
    items.forEach(function(el){
      if(window.matchMedia('(max-width:767px)').matches){
        el.setAttribute('role','button');
        el.setAttribute('aria-expanded','false');
      }
      el.addEventListener('click',function(){
        if(!window.matchMedia('(max-width:767px)').matches)return;
        setActive(el);
      });
      el.addEventListener('keydown',function(ev){
        if(!window.matchMedia('(max-width:767px)').matches)return;
        if(ev.key==='Enter'||ev.key===' '){ev.preventDefault();setActive(el);}
      });
    });
    var media=window.matchMedia('(max-width:767px)');
    function syncMode(){
      if(media.matches){
        showcase.setAttribute('data-bl-mobile-services-ready','true');
        items.forEach(function(el){el.setAttribute('role','button');});
        setActive(items.find(function(el){return el.classList.contains('is-active');})||items[1]||items[0]);
      }else{
        showcase.removeAttribute('data-bl-mobile-services-ready');
        items.forEach(function(el){el.removeAttribute('role');el.removeAttribute('aria-expanded');});
      }
    }
    if(media.addEventListener)media.addEventListener('change',syncMode);
    else if(media.addListener)media.addListener(syncMode);
    syncMode();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();

;

(()=>{const root=document.querySelector('#bl #etapa.bl-stage-scroll');if(!root)return;
const steps=[...root.querySelectorAll('.bl-stage-step')],socks=[...root.querySelectorAll('.bl-stage-sock')],dots=[...root.querySelectorAll('.bl-stage-dot')],fill=root.querySelector('.bl-stage-fill');
if(steps.length!==5||dots.length!==5||!fill)return;
let current=-1,manualUntil=0,pending=false;
function activate(i){i=Math.max(0,Math.min(4,i));if(current===i)return;current=i;steps.forEach((x,j)=>{x.classList.toggle('active',j===i);x.setAttribute('aria-pressed',String(j===i))});socks.forEach((x,j)=>x.classList.toggle('active',j===i));}
function paint(){pending=false;if(window.matchMedia('(max-width:767px)').matches)return;const r=root.getBoundingClientRect(),distance=Math.max(1,root.offsetHeight-innerHeight);const progress=Math.max(0,Math.min(1,-r.top/distance));const stage=progress*4;
if(Date.now()>manualUntil)activate(Math.min(4,Math.floor(stage+0.00001)));
fill.style.height=(progress*100)+'%';dots.forEach((dot,i)=>{dot.classList.toggle('is-passed',stage>=i-0.00001);dot.classList.toggle('active',i===current);dot.style.top=(i*25)+'%'});
}
function onScroll(){if(!pending){pending=true;requestAnimationFrame(paint)}}
steps.forEach((x,i)=>{function select(){if(window.matchMedia('(max-width:767px)').matches){activate(i);return;}manualUntil=Date.now()+850;const distance=Math.max(1,root.offsetHeight-innerHeight);window.scrollTo({top:window.scrollY+root.getBoundingClientRect().top+distance*i/4,behavior:'smooth'});activate(i);onScroll()}
x.addEventListener('click',e=>{if(e.target.closest('a'))return;select()});x.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();select()}})});
window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll,{passive:true});if(window.matchMedia('(max-width:767px)').matches)activate(0);paint();
})();

;
(function(){function init(){var h=document.querySelector('#bl-puro-hilo h2');if(!h)return;if(!('IntersectionObserver' in window)){h.classList.add('is-visible');return}var o=new IntersectionObserver(function(e){if(e[0].isIntersecting){h.classList.add('is-visible');o.disconnect()}},{threshold:.25});o.observe(h)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init()})();
;

(function(){
  function init(){
    var form=document.getElementById('brandlab-form');
    if(!form||form.dataset.blTrackingReady)return;
    form.dataset.blTrackingReady='1';
    var qs=new URLSearchParams(window.location.search);
    var keys=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid'];
    var found={};
    keys.forEach(function(k){
      var v=qs.get(k);
      if(v){found[k]=v.slice(0,180);}
    });
    try{
      var saved=JSON.parse(sessionStorage.getItem('bl_form_attribution')||'{}');
      found=Object.assign({},saved,found);
      sessionStorage.setItem('bl_form_attribution',JSON.stringify(found));
    }catch(e){}
    var tc=null;
    try{if(typeof window.TC_ORIGEN==='function')tc=window.TC_ORIGEN();}catch(e){}
    var fields={
      'bl-contact-utm-source':found.utm_source||(tc&&tc.src)||'',
      'bl-contact-utm-medium':found.utm_medium||(tc&&tc.med)||'',
      'bl-contact-utm-campaign':found.utm_campaign||(tc&&tc.camp)||'',
      'bl-contact-utm-content':found.utm_content||(tc&&tc.cont)||'',
      'bl-contact-utm-term':found.utm_term||'',
      'bl-contact-gclid':found.gclid||'',
      'bl-contact-fbclid':found.fbclid||'',
      'bl-contact-device':window.innerWidth<=767?'Móvil':'Escritorio/Tablet',
      'bl-contact-reference':window.location.pathname+(tc&&tc.code?' | Folio '+tc.code:'')
    };
    Object.keys(fields).forEach(function(k){var el=document.getElementById(k);if(el)el.value=fields[k];});
    var plan=document.getElementById('bl-plan-interest');
    if(plan){
      document.querySelectorAll('#bl #planes a[href="#cotizacion-brandlab"]').forEach(function(a){
        a.addEventListener('click',function(){
          var card=a.closest('.bl-flex-card');
          var name=card&&card.querySelector('.bl-plan-name');
          plan.value=name?name.textContent.trim():(a.textContent||'').trim();
        });
      });
    }
    form.addEventListener('submit',function(){var button=form.querySelector('button[type="submit"]');if(button&&form.checkValidity()){button.disabled=true;button.setAttribute('aria-busy','true');}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

;

(function(){
 document.querySelectorAll('#etapa .bl-stage-btn[data-plan-target]').forEach(function(btn){
  btn.addEventListener('click',function(e){
   var id=btn.getAttribute('data-plan-target'), plan=document.getElementById(id);
   if(!plan)return;
   e.preventDefault();
   history.replaceState(null,'','#'+id);
   plan.scrollIntoView({behavior:'smooth',block:'center'});
   document.querySelectorAll('#planes .bl-plan--focus').forEach(function(x){x.classList.remove('bl-plan--focus')});
   window.setTimeout(function(){
    plan.classList.remove('bl-plan--focus');
    void plan.offsetWidth;
    plan.classList.add('bl-plan--focus');
    window.setTimeout(function(){plan.classList.remove('bl-plan--focus')},1900);
   },520);
  });
 });
})();

;

(function(){
 function initBLTimeline(){
  var section=document.getElementById('tu-idea-toma-forma');if(!section)return;
  if(window.matchMedia('(max-width:767px)').matches)return;
  var cards=[...section.querySelectorAll('.bl-idea-card')],dots=[...section.querySelectorAll('.bl-scroll-dot')],bar=section.querySelector('.bl-scroll-progress');
  if(cards.length!==4||dots.length!==4||!bar)return;
  var pending=false,last=-1;
  function update(){
   pending=false;
   var rect=section.getBoundingClientRect(),distance=Math.max(1,section.offsetHeight-window.innerHeight);
   var p=Math.max(0,Math.min(1,-rect.top/distance)),step=p*3,active=Math.min(3,Math.floor(step+0.00001));
   bar.style.width=(Math.max(0,Math.min(100,step/3*100)))+'%';
   dots.forEach(function(dot,i){dot.classList.toggle('is-passed',step>=i-.00001);dot.classList.toggle('is-current',i===active)});
   cards.forEach(function(card,i){
    var proximity=Math.max(0,1-Math.abs(step-i));
    var img=card.querySelector('.bl-idea-art');if(img)img.style.transform='scale('+(0.92+0.12*proximity).toFixed(3)+')';
    card.style.opacity=(0.77+0.23*proximity).toFixed(3);
   });
   last=active;
  }
  function onScroll(){if(!pending){pending=true;requestAnimationFrame(update)}}
  window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll,{passive:true});update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBLTimeline);else initBLTimeline();
})();

;

/* Fondo cuadriculado con desplazamiento suave (sin desplazar producto ni texto) */
(function(){
  var key='__tuCalcetinBLGridParallax';
  if(window[key]&&typeof window[key].refresh==='function'){
    window[key].refresh();
    return;
  }
  var targets=[],frame=0;
  var motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  function refresh(){
    targets=[
      {root:document.querySelector('#bl #etapa.bl-stage-scroll'),layer:document.querySelector('#bl #etapa .bl-stage-sticky')},
      {root:document.querySelector('#bl #tu-idea-toma-forma.bl-idea-scroll'),layer:document.querySelector('#bl #tu-idea-toma-forma .bl-idea-sticky')}
    ].filter(function(item){return item.root&&item.layer;});
    schedule();
  }
  function paint(){
    frame=0;
    var viewport=window.innerHeight||document.documentElement.clientHeight||1;
    var rate=window.innerWidth<=767?0.16:0.22;
    targets.forEach(function(item){
      if(motion.matches){
        item.layer.style.removeProperty('--bl-grid-parallax-y');
        return;
      }
      var bounds=item.root.getBoundingClientRect();
      if(bounds.bottom<0||bounds.top>viewport)return;
      var distance=Math.max(0,item.root.offsetHeight-item.layer.offsetHeight);
      var travel=Math.min(distance,Math.max(0,-bounds.top));
      item.layer.style.setProperty('--bl-grid-parallax-y',(-travel*rate).toFixed(1)+'px');
    });
  }
  function schedule(){
    if(!frame)frame=window.requestAnimationFrame(paint);
  }
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',refresh);
  if(motion.addEventListener)motion.addEventListener('change',schedule);
  else if(motion.addListener)motion.addListener(schedule);
  window[key]={refresh:refresh};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});
  else refresh();
})();

;

/* Brand Lab mobile navigation: compares existing cards and preserves plan/quantity in form. */
(function(){
  var root=document.getElementById('bl');
  if(!root)return;
  var picker=root.querySelector('.bl-mobile-plan-picker');
  if(!picker)return;
  var mobile=window.matchMedia('(max-width:767px)');
  var known={'plan-test':['TEST','60','START LAB'],'plan-react':['REACT','100','START LAB'],
             'plan-mix':['MIX','200','FULL BRAND'],'plan-fusion':['FUSION','300','FULL BRAND'],
             'plan-scale':['SCALE','1,000','FULL BRAND']};
  function selectPlan(id){
    var details=known[id],card=document.getElementById(id);
    if(!details||!card)return;
    picker.querySelectorAll('[data-bl-select-plan]').forEach(function(btn){
      btn.setAttribute('aria-pressed',String(btn.getAttribute('data-bl-select-plan')===id));
    });
    root.querySelectorAll('#planes .bl-flex-card').forEach(function(c){c.classList.toggle('bl-mobile-active-plan',c.id===id);});
    root.querySelectorAll('#planes .bl-plan-family').forEach(function(f){
      f.classList.toggle('bl-mobile-family-hidden',!f.contains(card));
    });
    root.dataset.blMobileSelected=id;
    root.classList.add('bl-mobile-plans-ready');
  }
  function putInForm(id){
    var details=known[id];if(!details)return;
    var select=document.getElementById('bl-contact-quantity');
    var hidden=document.getElementById('bl-plan-interest');
    var summary=document.getElementById('bl-mobile-plan-summary');
    var value=details[1]+' pares';
    if(select){
      var match=Array.prototype.some.call(select.options,function(opt){return opt.value===value});
      if(match){select.value=value;select.dispatchEvent(new Event('change',{bubbles:true}));}
    }
    if(hidden)hidden.value=details[0];
    if(summary){
      summary.textContent='Tu selección: '+details[0]+' · '+value+'. Puedes modificar la cantidad en el formulario.';
      summary.hidden=false;
    }
  }
  function init(){
    if(root.dataset.blMobilePlanInit)return;
    root.dataset.blMobilePlanInit='1';
    var id=window.location.hash.slice(1);
    selectPlan(known[id]?id:'plan-fusion');
    picker.querySelectorAll('[data-bl-select-plan]').forEach(function(btn){
      btn.addEventListener('click',function(){
        selectPlan(btn.getAttribute('data-bl-select-plan'));
      });
    });
    /* Captura antes del antiguo scroll al plan: el destino debe estar visible. */
    root.querySelectorAll('#etapa .bl-stage-btn[data-plan-target]').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(mobile.matches)selectPlan(btn.getAttribute('data-plan-target'));
      },true);
    });
    root.querySelectorAll('#planes .bl-flex-card a[href="#cotizacion-brandlab"]').forEach(function(link){
      link.addEventListener('click',function(){
        if(mobile.matches)putInForm(link.closest('.bl-flex-card').id);
      });
    });
    root.querySelectorAll('#planes .bl-plans-bottom-cta a[href="#cotizacion-brandlab"]').forEach(function(link){
      link.addEventListener('click',function(){
        if(mobile.matches&&root.dataset.blMobileChosen==='true')putInForm(root.dataset.blMobileSelected);
      });
    });
    picker.querySelectorAll('[data-bl-select-plan]').forEach(function(btn){
      btn.addEventListener('click',function(){root.dataset.blMobileChosen='true';});
    });
    /* Mantener sincronizada la elección si el cliente cambia los pares manualmente. */
    var quantity=document.getElementById('bl-contact-quantity');
    var formPlan=document.getElementById('bl-plan-interest');
    var summary=document.getElementById('bl-mobile-plan-summary');
    if(quantity){
      quantity.addEventListener('change',function(){
        if(!mobile.matches)return;
        var ids=Object.keys(known);
        var match=ids.find(function(id){return known[id][1]+' pares'===quantity.value;});
        if(match){
          selectPlan(match);
          if(formPlan)formPlan.value=known[match][0];
          if(summary&&!summary.hidden)summary.textContent='Tu selección: '+known[match][0]+' · '+quantity.value+'. Puedes ajustar tu proyecto antes de enviarlo.';
        }else{
          if(formPlan)formPlan.value='';
          if(summary&&!summary.hidden){
            summary.textContent=quantity.value?'Cantidad elegida: '+quantity.value+'. Prepararemos una cotización a la medida.':'Selecciona una cantidad para continuar.';
          }
        }
      });
    }
    window.addEventListener('hashchange',function(){
      var newId=window.location.hash.slice(1);if(mobile.matches&&known[newId])selectPlan(newId);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();

;

/* Brand Lab: cambiar entre modelos casuales y deportivos, solo en movil */
(function(){
  function init(){
    var section=document.getElementById('bl-confeccion-altura');
    if(!section||section.dataset.blHeightTabsReady)return;
    section.dataset.blHeightTabsReady='true';
    var gallery=section.querySelector('.bl-height-gallery');
    var buttons=Array.prototype.slice.call(section.querySelectorAll('[data-bl-height-kind]'));
    if(!gallery||buttons.length!==2)return;
    function activate(kind){
      if(kind!=='casual'&&kind!=='deportivo')return;
      gallery.setAttribute('data-bl-active-kind',kind);
      buttons.forEach(function(btn){
        btn.setAttribute('aria-pressed',String(btn.getAttribute('data-bl-height-kind')===kind));
      });
    }
    buttons.forEach(function(btn){btn.addEventListener('click',function(){activate(btn.getAttribute('data-bl-height-kind'));});});
    activate('casual');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();

;

/* Brand Lab: seleccionar tipo de proyecto desde las seis categorias en movil */
(function(){
function init(){
 var section=document.querySelector('#bl #que-quieres-crear');
 if(!section||section.dataset.blUseMobileReady==='1')return;
 var cards=Array.prototype.slice.call(section.querySelectorAll('.bl-use[data-bl-project-type]'));
 var footer=section.querySelector('.bl-mobile-use-followup');
 var note=section.querySelector('.bl-mobile-use-choice');
 var select=document.getElementById('bl-contact-project');
 if(cards.length!==6||!footer||!note||!select)return;
 section.dataset.blUseMobileReady='1';
 var mobile=window.matchMedia('(max-width:767px)');
 var chosen=null;
 function applyMode(){
  cards.forEach(function(card){
   if(mobile.matches){card.setAttribute('role','button');card.setAttribute('tabindex','0');card.setAttribute('aria-pressed',String(card===chosen));}
   else{card.removeAttribute('role');card.removeAttribute('tabindex');card.removeAttribute('aria-pressed');card.classList.remove('is-active');}
  });
  if(!mobile.matches)footer.hidden=true;
  else if(chosen)choose(chosen);
 }
 function choose(card){
  if(!mobile.matches)return;
  var type=card.getAttribute('data-bl-project-type');
  var exists=Array.prototype.some.call(select.options,function(o){return o.value===type;});
  if(!exists)return;
  chosen=card;
  select.value=type;
  select.dispatchEvent(new Event('change',{bubbles:true}));
  cards.forEach(function(el){var on=el===card;el.classList.toggle('is-active',on);el.setAttribute('aria-pressed',String(on));});
  var heading=card.querySelector('h3');
  note.textContent='Elegiste: '+(heading?heading.textContent.trim():type)+'. Puedes cambiarlo en el formulario.';
  footer.hidden=false;
 }
 cards.forEach(function(card){
  card.addEventListener('click',function(){choose(card)});
  card.addEventListener('keydown',function(e){if(!mobile.matches)return;if(e.key==='Enter'||e.key===' '){e.preventDefault();choose(card);}});
 });
 if(mobile.addEventListener)mobile.addEventListener('change',applyMode);
 else if(mobile.addListener)mobile.addListener(applyMode);
 applyMode();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

;

(function(){
 function initBrandGallery(){
  const gallery=document.querySelector('#bl .bl-gallery-track');if(!gallery||gallery.dataset.ready)return;gallery.dataset.ready='1';
  const cards=Array.from(gallery.querySelectorAll('[data-bl-gallery-card]'));
  function activate(card){cards.forEach(c=>{const active=c===card;c.classList.toggle('is-active',active);c.setAttribute('aria-pressed',String(active))});if(window.matchMedia('(max-width:600px)').matches){card.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'})}}
  cards.forEach(card=>{card.addEventListener('click',()=>activate(card));card.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'||e.pointerType==='pen')activate(card)})});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBrandGallery);else initBrandGallery();
 document.addEventListener('shopify:section:load',initBrandGallery);
})();

;

(function(){function initBrandCover(){var root=document.querySelector('#bl #proyectos-reales .bl-cover-gallery');if(!root||root.dataset.coverReady)return;root.dataset.coverReady='1';var cards=Array.from(root.querySelectorAll('.bl-cover-card'));var index=2;var count=root.parentElement.querySelector('.bl-cover-count');function render(){cards.forEach(function(card,i){var p=(i-index+cards.length)%cards.length;if(p>2)p-=cards.length;card.dataset.pos=String(p);card.setAttribute('aria-pressed',String(p===0));card.tabIndex=Math.abs(p)<=1?0:-1});if(count)count.textContent=String(index+1).padStart(2,'0')+' / '+String(cards.length)}function move(d){index=(index+d+cards.length)%cards.length;render()}root.querySelector('.bl-cover-prev').addEventListener('click',function(){move(-1)});root.querySelector('.bl-cover-next').addEventListener('click',function(){move(1)});cards.forEach(function(card,i){card.addEventListener('click',function(){index=i;render()})});var sx=null;root.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});root.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40)move(dx<0?1:-1);sx=null},{passive:true});render()}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBrandCover);else initBrandCover();document.addEventListener('shopify:section:load',initBrandCover)})();
